import { createContext, useContext } from 'react'

const SSRContext = createContext(false)

export const SSRProvider = SSRContext.Provider
export const useIsSSR = () => useContext(SSRContext)
